<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择载具"
      width="1000px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :columns-btn-show="false"
        :filter.sync="filter"
        module="basic"
        url="vehicles">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="载具编号：">
            <el-input v-model.trim="filter.vehicleNo" placeholder="请输入载具编号" clearable/>
          </vm-search>
          <vm-search label="载具名称：">
            <el-input v-model.trim="filter.vehicleName" placeholder="请输入载具名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="vehicleNo" align="center" label="载具编号" width="100"/>
      <el-table-column prop="vehicleName" align="left" label="载具名称"/>
      <el-table-column prop="length" align="center" width="80" label="长度"/>
      <el-table-column prop="width" align="center" width="80" label="宽度"/>
      <el-table-column prop="lengthLimit" align="center" width="80" label="限长"/>
      <el-table-column prop="widthLimit" align="center" width="80" label="限宽"/>
      <el-table-column prop="load" align="center" width="80" label="载重"/>
      <el-table-column label="操作" align="center" width="80px" prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "VehicleSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {},
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>
